import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@app/api/api-services/auth.service';
import { RouteHelperService } from '@app/shared/services';

@Component({
  templateUrl: './signed-out.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SignedOutComponent implements OnInit {
  constructor(private readonly authService: AuthService, private readonly routeHelper: RouteHelperService) {}

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.routeHelper.logout();
    } else {
      this.routeHelper.login();
    }
  }
}
